<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 采购审批管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      是否启用采购审批流程

      <el-switch
        v-model="flag"
        @change="handleSwitch($event)"
        active-color="#13ce66"
        inactive-color="#808A87"
      >
      </el-switch>
    </div>
    <div class="container">
      <el-form :inline="true" :model="query" ref="query">
        <el-form-item label="审批流程名称" prop="workflowDefinitionName">
          <el-input
            v-model="query.workflowDefinitionName"
            placeholder="审批流程名称"
            :disabled="!flag"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="primary" @click="handleClear">重置</el-button>
      </el-form>
    </div>
    <div class="container">
      <div style="margin-bottom: 20px">
        <el-button
          type="primary"
          @click="goToUrl('/createPurchaseAudit')"
          style="float: right; margin-bottom: 20px"
          >新增审批流程</el-button
        >
      </div>

      <TableList
        :selectionShow="flag"
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :table-option="tableOption"
        :selection-show="true"
        :row-key="rowKey"
        @handleButton="handleButton"
        @handleSortChange="handleSortChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <template v-slot:index="slot">
          {{ slot.scope.$index + 1 }}
        </template>
      </TableList>
      <div class="pagination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="productTagPage.pageNum"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          :small="true"
          prev-text="上一页"
          next-text="下一页"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import TableList from "../../components/common/e-table-list";

import Api from "../../api/company/index";
export default {
  name: "",
  components: {
    TableList,
  },
  props: {},
  data () {
    return {
      query: {
        workflowDefinitionName: "",
      },
      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: "审批流程名称",
          param: "workflowDefinitionName",
          align: "center",
        },
        { label: "审批流程创建人", param: "createUserName", align: "center" },
        { label: "审批流程创建时间", param: "createTime", align: "center" },
      ],
      rowKey: 'workflowDefinitionId',
      tableOption: {
        label: "操作",
        width: "300",
        fixed: "right",
        permission: '0',
        options: [
          {
            label: "编辑",
            type: "text",
            permission: "/transaction-center/workflow/updateWorkflow",
            methods: "handleEdit",
            disabled: true,
          },
          {
            label: "删除",
            type: "text",
            permission: "/transaction-center/workflow/remo",
            methods: "handleDelete",
            disabled: true,
          },
        ],
      },
      productTagPage: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      addUserDialogShow: false,
      selectionData: [],
      resetPasswordShow: false,
      dialogTitle: "",
      checkUserShow: false,
      userData: {},
      flag: false,
    };
  },
  computed: {},
  watch: {
    flag: {
      immediate: true,
      deep:true,
      handler: function (newVal) {
         this.tableOption.options.forEach((item) => {
        item.disabled = !newVal;
      });
      },
    },
  },
  created () {
    this.getWorkflowList();
  },
  methods: {

    // 查询
    handleSearch () {
      this.productTagPage.pageNum = 1;
      this.productTagPage.pageSize = 10;
      this.getWorkflowList();
    },
    // 重置
    handleClear () {
      this.query.workflowDefinitionName = "";
      this.getWorkflowList();
    },

    // 删除审批流
    handleDelete (val) {
      if(this.tableData.length == 1){
        this.$confirm("您正在删除最后一条审批流程，删除此审批流程后将自动关闭审批开关，是否继续删除审批流程？", "提示", {
        confirmButtonText: "继续删除",
        cancelButtonText: "取消",
        // type: "warning",
      })
        .then(() => {
          this.handleDeleteOk(val);
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
      }else{
        this.handleDeleteOk(val);
      }
    },


    // 删除审批流程
    handleDeleteOk(val){
      this.$confirm("该审批流程将被删除，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          Api.removeWorkflow({
            workflowDefinitionId: val.row.workflowDefinitionId,
          }).then((res) => {
            if (res.code == "200") {
              if(!this.tableData.length){
                this.flag = false;
              }
              this.$message.success("删除成功!");
              this.getWorkflowList();
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    // 查询审批流
    getWorkflowList () {
      let params = {
        workflowDefinitionName: this.query.workflowDefinitionName,
        pageSize: this.productTagPage.pageSize,
        pageNum: this.productTagPage.pageNum,
      };
      Api.pageWorkflow(params).then((res) => {
        this.productTagPage.pageTotal = res.data.total;
        this.tableData = res.data.records;
        this.queryApprovalProcessSwitch();
        this.$setStore("getWorkflowListTableData", this.tableData);
      });
    },

    // table button
    handleButton (val) {
      switch (val.methods) {
        case "handleEdit":
          this.handleEdit(val);
          break;
        case "handleDelete":
          this.handleDelete(val);
          break;
      }
    },

    // 分页
    handleSizeChange (val) {
      this.productTagPage.pageSize = val;
      this.productTagPage.pageNum = 1
      this.getWorkflowList();
    },
    handleCurrentChange (val) {
      this.productTagPage.pageNum = val;
      this.getWorkflowList();
    },

    // 审批流开关查询
    async queryApprovalProcessSwitch () {
      let res = await Api.queryApprovalProcessSwitch();
      if (res.code == "200") {
        if (res.data.data == "41" && this.tableData.length) {
          this.flag = true; 
          this.tableOption.options.map((item) => (item.disabled = !this.flag));
        } else {
          this.flag = false;
        }
      } else {
        this.flag = false;
      }
    },

    // 修改审批流开关
    async handleSwitch (val) {
      let switchFlag = await Api.listWorkflow();
      if (switchFlag.data.length) {
        let res = await Api.saveApprovalProcessSwitch({
          data: val ? "41" : "42",
        });
        if (res.code == "200") {
          let message = val ? "采购审批流打开" : "采购审批流关闭";
          this.$message.success(message);
          this.getWorkflowList();
        }
      } else {
        this.flag = false;
        this.$message({
          type: 'warning',
          message: '请至少添加一条审批流程后再开启审批开关',
          duration: 5000
        })
      }
    },

    // 审批流编辑
    handleEdit (val) {
      this.$setStore("editConfirmWorkFlowSkusList", null);
      this.$setStore("editWorkflowDefinitionName", null);
      this.$setStore("editWorkFlowSkusList", null);
      this.$setStore("editTableData", null);
      this.$setStore("editConfirmWorkFlowSkusList", null);
      this.$setStore("workflowDefinitionId", val.row.workflowDefinitionId);
      this.$setStore("workflowDefinitionName", val.row.workflowDefinitionName);
      this.$router.push({
        name: "editPurchaseAudit",
        params: {
          path: "purchaseAudit",
          workflowDefinitionId: val.row.workflowDefinitionId,
        },
      });
    },
    goToUrl (url) {
      this.$setStore("createName", null);
      this.$setStore("createPurchaseAuditPath", { path: "purchaseAudit" });
      this.$setStore("workflowDefinitionName", "");
      this.$setStore("workFlowSkusList", null);
      this.$router.push({ path: url });
    },

    handleSortChange () { },
    handleSelectionChange (val) {
      this.selectionData = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
}
</style>
